import React, {useState} from 'react'
import '../css/common.css'
import { useNavigate } from 'react-router-dom';


import TitleChnage from "../Hook/TitleChnage";

import imageOne from "../resource/talks/F18 (2).png";
import imageOtwo from "../resource/talks/F18.png";
import imageThree from "../resource/talks/F19.png";
import imageFour from "../resource/talks/L22.png";
import imageFive from "../resource/talks/L23.png";
import imageSix from "../resource/talks/L24.png";
import imageNine from "../resource/talks/F17.png";

const DhammaTalks = () => {

    TitleChnage("Dhamma Talks")

    const navigate = useNavigate();

    const [isTextVisible,setIsTextVisible] = useState(false);

    const handleToggle = () => {
        setIsTextVisible((prev) => !prev);
    }

    const handleClick = (event) => {

        const pathMap = {
          dammatalksteahcer: '/dammatalksteahcer',
          variusteachers : '/variusteachers'
        }

        const path = event.currentTarget.id;
        const targetPath = pathMap[path]

        if (targetPath) {
            navigate(targetPath)
        }
    }

  return (
    <div className="page damma-talks-page">
      <img src={imageOne} alt="" className="left-imge" />
      <img src={imageOtwo} alt="" className="right-imge" />

      <header>
        <div className="home-icon">{/* <img src="#" alt="Home Icon"> */}</div>
        <div className="title">
          <h1>Dhamma Talks</h1>
          <img src={imageThree} width={400} />
        </div>
      </header>

      <section className="intro-text">
        <ul className='text-bold'>
            <li>A colorful fragrant beautiful flower</li>
            <li>Will give the wearer the benifit of aroma</li>
            <li>The Well delivered words if Buddha</li>
            <li>Will benefit one who practice Dhamma</li>
        </ul>
        <p className="meditate-info text-black">
          Bhaddeka Vihari Monastery has been dedicated to conducting numerous
          Dhamma programs both internally and externally. Since 2017, a substantial
          collection of Dhamma talks delivered during these programs 
          has been complied.<span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "" : "more"}</span>

        </p>

        {isTextVisible &&
                <div className="hidden-text">
                  
                <p className="dana-info text-black">The collection is enriched by the presence of many eminent Dhamma teachers within the Sangha community, touching a wide array of topics, including the principal discourses delivered by the Buddha. In addition, sermons related to meditation instructions, guided meditations, and Dhamma discussions are also included.
          <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "less" : ""}</span>

                </p>
               </div>
               }
      </section>

      <section className="button-section">
        <div className="left-col">
          <img src={imageFour} alt="" width={300} id='dammatalksteahcer' onClick={handleClick}/>
          
        </div>
        <div className="middle-col">
        <img src={imageFive} alt="" width={300} />
         
        </div>
        <div className="right-col">
        <img src={imageSix} alt="" width={300} id='variusteachers' onClick={handleClick}/>
        </div>
      </section>

      <div className="box">
        <img src={imageNine} alt="" className="bottom-imge" />
      </div>
    </div>
  )
}

export default DhammaTalks
